/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Input } from "antd";
import { IModelInfo, IModelMemberInfo } from "../../domain/ModelInfos/IModelInfo";
import { DatabaseOutlined, DeleteOutlined, EditOutlined, FolderOutlined, PlusCircleOutlined, StarOutlined } from "@ant-design/icons";
import { ModelMemberEditor } from "./ModelMemberEditor";
import { useCallback, useState } from "react";
import { debounce } from "throttle-debounce";
import { nanoid } from "nanoid";
import { domain } from "../../domain/domain";

export function ModelInfoEditor(props: { model: IModelInfo, triggerUpdate?: () => any }) {
    const [model, setModel] = useState<IModelInfo>(props.model);
    const modelChange = (changedProps: Partial<IModelInfo>) => {
        const newModel = { ...model, ...changedProps };
        newModel.rev = nanoid();
        setModel(newModel);
        debouncedSave(newModel);
    };

    const debouncedSave = useCallback(debounce(1000, save), []);

    async function save(model: IModelInfo) {
        await domain.modelInfoService.save([model]);
    }

    async function onDelete(model: IModelInfo) {
        await domain.modelInfoService.delete(model.id);
        if (props.triggerUpdate)
            props.triggerUpdate();
    }

    function addMember() {
        const member: IModelMemberInfo = {
            id: nanoid(),
            name: "",
            type: {
                name: ""
            }
        };
        modelChange({ members: [...model.members, member] })
    }
    function memberChange(model: IModelInfo, member: IModelMemberInfo, changes: Partial<IModelMemberInfo>) {
        const index = model.members.findIndex(x => x.id === member.id);
        model.members[index] = { ...member, ...changes };
        modelChange(model);
    }

    function memberDelete(member: IModelMemberInfo) {
        model.members = model.members.filter(x => x.id !== member.id);
        modelChange(model);
    }

    return (<div><Card
        title={<>
            <Input size="middle" value={model.name} prefix={<StarOutlined />} onChange={e => modelChange({ name: e.target.value })} /><br />
            <Input size="small" value={model.originalName} prefix={<DatabaseOutlined />} onChange={e => modelChange({ originalName: e.target.value })} /><br />
            <Input size="small" value={model.namespace} prefix={<FolderOutlined />} onChange={e => modelChange({ namespace: e.target.value })} />
        </>}
        size="small"
        actions={[
            <PlusCircleOutlined key="add" onClick={() => addMember()} />,
            <EditOutlined key="edit" />,
            <DeleteOutlined key="delete" onClick={() => onDelete(model)} />,
        ]}>
        <div style={{ height: 350, overflow: "auto" }}>
            {model.members.map(x => <ModelMemberEditor key={x.id} model={model} modelMember={x} onChange={(changes) => memberChange(model, x, changes)} onDelete={memberDelete} />)}
        </div>
    </Card>
    </div>)
}

